var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css'; // Import Ant Design styles
import Comp from './Comp';
import i18n from './utils/i18nService'; // 导入 i18n 实例
import api from './api'; // 导入 api
// 在应用程序启动时设置语言
const initializeLanguage = () => __awaiter(void 0, void 0, void 0, function* () {
    const browserLanguage = navigator.language;
    const storageLanguage = localStorage.getItem('language');
    const defaultLanguageValue = browserLanguage.startsWith('zh') ? 'zh_CN' : 'en_US';
    const languageToSet = storageLanguage || defaultLanguageValue;
    try {
        yield i18n.changeLanguage(languageToSet);
        yield api.CoachCardApi.setLanguage({ language: languageToSet });
    }
    catch (error) {
        console.error('Failed to initialize language:', error); // 初始化语言失败
    }
});
initializeLanguage().then(() => {
    ReactDOM.render(<>
    <Comp />
  </>, document.getElementById('root'));
});
